import { useState, useEffect } from 'react'
import type { Dispatch, SetStateAction } from 'react'

/**
 * useState whose value survives navigation (e.g. opening Transaction Edit and coming
 * back) by mirroring into sessionStorage under `key`. Same API as useState.
 * Used by TransactionsTable to retain sort / P-B filter / page across the edit round-trip.
 */
export function usePersistedState<T>(key: string, initial: T): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = sessionStorage.getItem(key)
      return raw !== null ? (JSON.parse(raw) as T) : initial
    } catch {
      return initial
    }
  })

  useEffect(() => {
    try { sessionStorage.setItem(key, JSON.stringify(value)) } catch { /* quota / private mode */ }
  }, [key, value])

  return [value, setValue]
}
